import type { PullRequestDiscussionInput, PullRequestEditResult } from "@afar-research/contracts";
import { createStore } from "zustand/vanilla";
export function createPullRequestLifecycleSession() {
  return createStore<{
    users: string;
    teams: string;
    command: PullRequestDiscussionInput | null;
    pending: boolean;
    result: PullRequestEditResult | null;
  }>(() => ({ users: "", teams: "", command: null, pending: false, result: null }));
}
export type PullRequestLifecycleSession = ReturnType<typeof createPullRequestLifecycleSession>;
